module.exports = __webpack_public_path__ + "img/tp.c0d596f2.png";